import * as React from "react";
import styled, { css } from "styled-components";
import {
  ConstBreakPoint,
  ConstColor,
  ConstFontStyle,
  ConstFontWeight,
  ConstMargin,
} from "../../../../config/styles_const/styles_const";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  icon?: string;
  defaultMargin?: boolean;
}

const HeadlineSmallDefault: React.SFC<IProps> = (props) => {
  const { icon, defaultMargin, children, ...HeadlineProps } = props;

  return <h3 {...HeadlineProps}>{children}</h3>;
};

const HeadlineSmall = styled(HeadlineSmallDefault)`
  color: ${ConstColor.Base};
  font-style: normal;
  font-weight: ${ConstFontStyle.SpHeadlineSmall.fontWeight};
  font-size: 15px;
  line-height: ${ConstFontStyle.SpHeadlineSmall.lineHeight};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    font-weight: ${ConstFontStyle.HeadlineSmall.fontWeight};
    font-size: 15px;
    line-height: ${ConstFontStyle.HeadlineSmall.lineHeight};
  }

  & > em {
    font-style: inherit;
    font-weight: ${ConstFontWeight.BOLD};
    background: ${ConstColor.TableTh};
    padding: 0 5px;
  }

  ${(props) =>
    props.defaultMargin &&
    css`
      margin-bottom: ${ConstMargin.SpHeadlineSmallBottom};
      @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: ${ConstMargin.HeadlineSmallBottom};
      }
    `}
  ${(props) =>
    props.icon &&
    css`
      ::before {
        margin-right: ${ConstMargin.HeadlineIconRight};
        content: ${props.icon};
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
      }
    `}
`;

export default HeadlineSmall;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/headline_small.tsx